import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '../../utils/env';
export default function BrowseListSchema({ title, items }) {
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Postpop', item: SITE_URL },
            { '@type': 'ListItem', position: 2, name: title },
          ],
        })}
      </script>
      {items.length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            itemListElement: items
              .filter((item) => item.image)
              .map((item, index) => ({
                '@type': 'ListItem',
                position: index + 1,
                name: item.title,
                image: item.image,
                url: `${SITE_URL}${item.to}`,
              })),
          })}
        </script>
      )}
    </Helmet>
  );
}
